/**
 * Public offer layout route — /public/offers/:token
 *
 * Pure layout: renders only `<Outlet />`. The exact-match page content lives in
 * `$token.index.tsx` (the offer page itself); the anonymous unit detail child
 * route (`$token.units.$unitId.tsx`) also nests under this route. Both siblings
 * need a parent that actually renders an `<Outlet />` — TanStack Router never
 * shows a child route's component otherwise, it just leaves the parent's own
 * component on screen (client-offer-unit-detail-page / CU-86cbde3ae: the
 * anonymous unit detail route was unreachable by direct navigation before this
 * split, only its component-level unit tests — which render it in isolation
 * outside the real route tree — ever passed).
 *
 * `pendingComponent`/`errorComponent` stay here rather than moving to the index
 * route so they also cover the units child route: TanStack's `errorComponent`
 * acts as an error boundary for the whole matched subtree, and the unit detail
 * route re-throws any error it does not recognize as expired/not-found.
 *
 * The root auth guard allow-lists /public/* so no redirect to /login occurs.
 * AppShell is skipped in RootComponent for /public/* paths.
 *
 * Traceability: public-offer-client-link / Requirement: Public Offer Page
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ClientOfferPageLoading, PublicOfferInvalidPage } from '@ooh/screens';

export const Route = createFileRoute('/public/offers/$token')({
  pendingComponent: ClientOfferPageLoading,
  errorComponent: PublicOfferInvalidPage,
  component: () => <Outlet />,
});
